import { rei } from "@/services/api"

class AssinaturasPendentesService {
  static getPendentes (params) {
    return  rei.get(`assinaturas/registros/pendentes`, { params }).then(res => res.data)
  }
}

export default AssinaturasPendentesService
